import { toast as rtToast } from 'react-toastify';

import { SESSION_EXIT_MESSAGES, TOAST_PRESETS } from './presets';

function mergePreset(preset, opts) {
  return { ...preset, ...opts };
}

function resolveSessionMessage(reason) {
  return SESSION_EXIT_MESSAGES[reason] ?? SESSION_EXIT_MESSAGES.token_invalid;
}

export const toast = {
  success: (msg, opts) => rtToast.success(msg, mergePreset(TOAST_PRESETS.success, opts)),

  error: (msg, opts) => rtToast.error(msg, mergePreset(TOAST_PRESETS.error, opts)),

  warning: (msg, opts) => rtToast.warning(msg, mergePreset(TOAST_PRESETS.warning, opts)),

  info: (msg, opts) => rtToast.info(msg, mergePreset(TOAST_PRESETS.info, opts)),

  /**
   * Session exit（登出／改密／401）。colored + progress 5s；文案不含倒數說明。
   * 預設 `toastId: 'session-exit'` 避免重複堆疊。
   * @param {string} reason — `logout_success` | `password_changed` | `token_expired` | …
   * @param {object} [opts]
   */
  session: (reason, opts) => {
    const message = resolveSessionMessage(reason);
    const preset = mergePreset(TOAST_PRESETS.session, {
      toastId: 'session-exit',
      ...opts,
    });

    if (reason === 'logout_success' || reason === 'password_changed') {
      return rtToast.info(message, preset);
    }

    return rtToast.error(message, preset);
  },

  promise: (promise, messages, opts) => rtToast.promise(promise, messages, opts),

  dismiss: (id) => rtToast.dismiss(id),
};
